
export enum FILE_TYPE {
  TOOL = "tool",
  MODEL = "model",
}

export interface File {
  name: string;
  product: string;
  filename: string;
  order: number;
  content: string;
  description: string;
  version: string;
  type: FILE_TYPE;
  showIsNew: boolean;
  isActive: boolean;
}

export interface GetFileResponse extends File {
  updatedAt: string;
}

export const FILE_TYPE_LABELS: Record<FILE_TYPE, string> = {
  [FILE_TYPE.TOOL]: "Tool",
  [FILE_TYPE.MODEL]: "Model",
}